import React, { FC } from 'react';
import { DateField, Text } from '@sitecore-jss/sitecore-jss-react';
import { THeadingTag, TImageField, TSitecoreContext } from '../../../../types/types';
import { TLatestNewsCardItemProps } from '../../types/latestNews.types';
import { NewsCardModel } from './models/newsCard.model';
import ctaTypes from '../../../../enums/CTA.enums';
import Media from '../media';
import useFormatDate from '../../../../hooks/useFormatDate';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import CTA from '../../../@shared/cta';
import { getDLMFormatDate, googleClickNewsCtaEvent } from '../../../../utils/analytics';
import { TSocialMediaBarProps } from '../../../@shared/socialMediaBar/types/socialMediaBar.types';
import SocialMediaBar from '../../../@shared/socialMediaBar';

const NewsCard: FC<{
  item: TLatestNewsCardItemProps;
  cardHeadingTitleTag: THeadingTag;
  sitecoreContext: TSitecoreContext;
  defaultCardImage?: TImageField;
  readMoreKey: string;
  index: number;
  socialMediaBarProps?: TSocialMediaBarProps;
}> = ({ item, cardHeadingTitleTag, sitecoreContext, defaultCardImage, readMoreKey, index, socialMediaBarProps }): JSX.Element => {
  const model = new NewsCardModel(item, sitecoreContext);
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-l']})`);
  const formattedDate = useFormatDate(model.newsDate?.value);
  const formattedDLMDate = model.newsDate?.value ? getDLMFormatDate(model.newsDate.value) : '';
  const shareURL = new URL(model.ctaLink || '', sitecoreContext?.currentPageUrl as string || '').href;

  return (
    <article className="latest-news-card">
      {model?.tag?.value && (
        <div className={'latest-news-card__tag'}>
          <Text field={model?.tag} tag={'div'} editable={false} className={'latest-news-card__tag--text'} />
        </div>
      )}

      <Media
        desktopImage={model?.image}
        mobileImage={model?.mobileImage}
        isDesktop={isWide}
        useVideo={model?.showVideo}
        videoUrl={model?.video}
        defaultImage={defaultCardImage}
      />
      <div className="latest-news-card__content--wrapper">
        <div className="latest-news-card__content--body">
          <div className='latest-news-card__content--date-share'>
            {model?.newsDate && (
              <DateField
                field={model.newsDate}
                tag="div"
                className="latest-news-card__content--date"
                render={() => formattedDate}
                editable={false}
              />
            )}
            {socialMediaBarProps && (
              <SocialMediaBar
                {...socialMediaBarProps}
                listType='dropdown'
                useAnalytics={true}
                shareURL={shareURL}
                showInMobile={true}
              />
            )}
          </div>
          {model?.title && (
            <Text field={model?.title} tag={cardHeadingTitleTag} className="latest-news-card__content--title" editable={false} />
          )}
          {model?.shortDescription && (
            <Text field={model?.shortDescription} tag={'div'} className="latest-news-card__content--description" editable={false} />
          )}
        </div>

        <div className="latest-news-card__content--button">
          {model?.ctaLink && (
            <CTA
              type={ctaTypes.primaryRed}
              href={model.ctaLink}
              onClick={() => googleClickNewsCtaEvent(model.title?.value || '', index + 1, model.tag?.value, formattedDLMDate)}
            >
              {readMoreKey}
            </CTA>
          )}
        </div>
      </div>
    </article>
  );
};

export default NewsCard;
